import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

import { apiGet } from "../../Api/Client.js";
import "../../Styles/DocsPortalScreen.css";

// A standalone "terms"-style link, not a Documents project: a company
// policy every employee is bound by (currently one document — the
// internship conduct/compliance text) rather than a project's own
// engineering documentation. Self-service for everyone, see pages.py
// "company_policies". No sidebar entry on purpose, same as My Profile —
// reached by sharing this URL directly, not by browsing to it.
export function CompanyPolicyScreen() {
  const [page, setPage] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    setError("");
    apiGet("/EnterpriseCore/company-policy/")
      .then((res) => setPage(res))
      .catch((err) => setError(err?.payload?.detail || err?.message || "Could not load this page."))
      .finally(() => setLoading(false));
  }, []);

  return (
    <section className="Docs-Portal Screen-Stack">
      <div className="Docs-Portal-Content">
        {loading && <p className="Docs-Portal-Muted">Loading…</p>}
        {!loading && error && <p className="Docs-Portal-Error">{error}</p>}
        {!loading && page && (
          <article className="Docs-Portal-Article">
            <div className="Docs-Portal-Article-Head">
              <h2>{page.title}</h2>
            </div>
            <div className="Docs-Portal-Markdown">
              <ReactMarkdown remarkPlugins={[remarkGfm]}>{page.body}</ReactMarkdown>
            </div>
          </article>
        )}
      </div>
    </section>
  );
}
